import { render } from "./list.vue?vue&type=template&id=20a50cf1"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=20a50cf1&lang=scss"
script.render = render

export default script